// shufflejs.js
import Shuffle from 'shufflejs';

export function initCaseStudyShuffle(root = document) {
    const container = root.querySelector('.dpage-app-shufflejs');
    if (!container) return;

    // Destroy prior instance (PJAX safety)
    if (container._shuffle) {
        container._shuffle.destroy();
        container._shuffle = null;
    }

    const shuffle = new Shuffle(container, {
        itemSelector: '.dpage-app-shufflejs-item',
        // columnWidth: (containerWidth) => 0.18 * containerWidth,
        // sizer: container.querySelector('.dpage-app-shufflejs-sizer'),
        delimiter: ',', // you’re using data-groups as JSON; fine to keep
    });
    container._shuffle = shuffle;

    // Ensure images are loaded before final layout to prevent wrong sizing
    const imgs = Array.from(container.querySelectorAll('img'));
    const waits = imgs
        .filter(img => !img.complete)
        .map(img => new Promise(res => {
            img.addEventListener('load', res, { once: true });
            img.addEventListener('error', res, { once: true });
        }));
    Promise.all(waits).then(() => shuffle.layout());

    // Debounced relayout on window resize
    let resizeTimer;
    const onResize = () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => shuffle.layout(), 100);
    };
    window.addEventListener('resize', onResize);
    // Cleanup on destroy
    const oldDestroy = shuffle.destroy.bind(shuffle);
    shuffle.destroy = () => {
        window.removeEventListener('resize', onResize);
        oldDestroy();
    };

    // Filters
    const buttons = root.querySelectorAll('.case-studies-filter');
    buttons.forEach((btn) => {
        btn.addEventListener('click', () => {
            buttons.forEach(b => b.classList.remove('is-active'));
            btn.classList.add('is-active');

            const group = btn.getAttribute('data-group');
            if (!group || group === 'all') {
                shuffle.filter(Shuffle.ALL_ITEMS);
            } else {
                shuffle.filter((el) => {
                    try {
                        const groups = JSON.parse(el.getAttribute('data-groups') || '[]');
                        return groups.includes(group);
                    } catch { return false; }
                });
            }
        });
    });
}
